/**
 * VUE USE
 * Register any Vue plugins
 */

import Vue from "vue";
import * as VueGoogleMaps from "vue2-google-maps";

Vue.use(VueGoogleMaps, {
    installComponents: false,
    load: {
        key: document.head.querySelector("meta[name='google-maps-api-key']").getAttribute('content') || null,
    },
})
